import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const isAdminRoute = pathname === '/crac-console' || pathname.startsWith('/admin');
  const isLoginRoute = pathname === '/admin/login';
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen flex flex-col"
    >
      {!isAdminRoute && <Header />}
      <AnimatePresence mode="wait">
        <motion.main 
          key={window.location.pathname}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className={`flex-1 ${isAdminRoute ? 'pt-4' : 'pt-32 sm:pt-28'}`}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      {!isLoginRoute && <Footer />}
    </motion.div>
  );
};

export default Layout;